/**
 * C-323d · «Catálogo de daños» (sólo admin): los tipos de daño y las ubicaciones/piezas que se eligen en
 * «¿Hay daño? → Sí» de la Recepción. Se agrega, se renombra, se reordena y se desactiva; nunca se borra
 * (los daños viejos siguen apuntando a su renglón). El candado está en el servidor (requireRole admin).
 *
 *   import { abrirCatalogoDanos } from '../utils/catalogoDanosAdmin.js';
 *   abrirCatalogoDanos();
 */

import api from '../services/api.js';
import modal from './modal.js';
import toast from './toast.js';
import { cargarCatalogosDanos } from './danosRecepcion.js';

const CLASIF = { PINT: 'Pintura y hojalatería', NEUM: 'Neumáticos', ELEC: 'Eléctrico', REFA: 'Refacción' };
const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

function filaHtml(cat, o) {
  const clasif = cat === 'tipo'
    ? `<select class="form-select cd-clasif" style="min-width:140px;">
         <option value="" ${o.clasificacion ? '' : 'selected'}>Sin clasificar</option>
         ${Object.entries(CLASIF).map(([k, v]) => `<option value="${k}" ${o.clasificacion === k ? 'selected' : ''}>${v}</option>`).join('')}
       </select>`
    : '';
  return `<tr data-id="${o.id}" data-cat="${cat}" style="${o.activo ? '' : 'opacity:0.55;'}">
    <td><input class="form-input cd-nombre" maxlength="80" value="${esc(o.nombre)}" style="min-width:160px;"></td>
    ${cat === 'tipo' ? `<td>${clasif}</td>` : ''}
    <td><input class="form-input cd-orden" type="number" min="0" max="9999" value="${o.orden}" style="width:70px;"></td>
    <td style="text-align:center;"><input type="checkbox" class="cd-exige" ${o.exige_descripcion ? 'checked' : ''} title="Pide descripción («Otro»)"></td>
    <td style="text-align:center;"><input type="checkbox" class="cd-activo" ${o.activo ? 'checked' : ''}></td>
    <td><button type="button" class="btn btn-sm btn-primary cd-guardar">Guardar</button></td>
  </tr>`;
}

function tablaHtml(cat, titulo, lista) {
  return `<h4 style="margin:0.75rem 0 0.4rem;">${titulo}</h4>
    <div style="overflow-x:auto;"><table class="table" style="width:100%;font-size:0.85rem;">
      <thead><tr><th>Nombre</th>${cat === 'tipo' ? '<th>Clasificación</th>' : ''}<th>Orden</th><th>Pide descripción</th><th>Activo</th><th></th></tr></thead>
      <tbody>${lista.map((o) => filaHtml(cat, o)).join('')}</tbody>
    </table></div>
    <div style="display:flex;gap:0.5rem;margin-top:0.4rem;flex-wrap:wrap;">
      <input class="form-input cd-nuevo-nombre" data-cat="${cat}" maxlength="80" placeholder="Agregar ${cat === 'tipo' ? 'tipo de daño' : 'ubicación o pieza'}" style="flex:1;min-width:180px;">
      ${cat === 'tipo' ? `<select class="form-select cd-nuevo-clasif" style="min-width:140px;"><option value="">Sin clasificar</option>${Object.entries(CLASIF).map(([k, v]) => `<option value="${k}">${v}</option>`).join('')}</select>` : ''}
      <button type="button" class="btn btn-sm btn-secondary cd-agregar" data-cat="${cat}">+ Agregar</button>
    </div>`;
}

async function pintar(cont) {
  const r = await api.get('/calidad/catalogo-danos', { todos: '1' });
  const d = r?.data || { tipos: [], ubicaciones: [] };
  cont.innerHTML = `
    <p style="font-size:0.8rem;color:var(--gray-500);margin:0;">
      Es lo que se elige en Recepción → «¿Hay daño? → Sí». Un renglón no se borra: se desactiva y deja de salir en la lista.
      La clasificación del tipo es la que agrupa los planes de acción en el PNC.
    </p>
    ${tablaHtml('tipo', 'Tipos de daño', d.tipos)}
    ${tablaHtml('ubicacion', 'Ubicaciones o piezas', d.ubicaciones)}`;
}

export async function abrirCatalogoDanos() {
  const cont = document.createElement('div');
  cont.id = 'catalogoDanosAdmin';
  cont.innerHTML = '<p>Cargando…</p>';
  modal.open('Catálogo de daños', cont, [{ text: 'Cerrar', class: 'btn-secondary', closeOnClick: true }]);
  try {
    await pintar(cont);
  } catch (e) {
    cont.innerHTML = `<p style="color:var(--danger);">No se pudo cargar: ${esc(e.message)}</p>`;
    return;
  }
  cont.addEventListener('click', async (ev) => {
    const guardar = ev.target.closest('.cd-guardar');
    const agregar = ev.target.closest('.cd-agregar');
    try {
      if (guardar) {
        const tr = guardar.closest('tr');
        const body = {
          nombre: tr.querySelector('.cd-nombre').value,
          orden: tr.querySelector('.cd-orden').value,
          exige_descripcion: tr.querySelector('.cd-exige').checked,
          activo: tr.querySelector('.cd-activo').checked
        };
        const cl = tr.querySelector('.cd-clasif');
        if (cl) body.clasificacion = cl.value || null;
        await api.put(`/calidad/catalogo-danos/${tr.dataset.id}`, body);
        toast.success('Guardado');
      } else if (agregar) {
        const cat = agregar.dataset.cat;
        const caja = agregar.parentElement;
        const nombre = caja.querySelector('.cd-nuevo-nombre').value;
        const cl = caja.querySelector('.cd-nuevo-clasif');
        await api.post('/calidad/catalogo-danos', { catalogo: cat, nombre, ...(cl ? { clasificacion: cl.value || null } : {}) });
        toast.success('Agregado');
      } else {
        return;
      }
      await cargarCatalogosDanos({ forzar: true }).catch(() => null);
      await pintar(cont);
    } catch (e) {
      toast.error(e.message || 'No se pudo guardar');
    }
  });
}
